import script from "./ComponentWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ComponentWrapper.vue?vue&type=style&index=0&id=193840f3&lang=scss"

const __exports__ = script;

export default __exports__